import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { AuthService } from "../providers/auth.service";
import { map, catchError, switchMap, retry, tap } from "rxjs/operators";
import { apiLinks } from "../core/api-links/api-links";
import { timeout } from 'rxjs/operators';
import { isEmpty } from 'lodash';
export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
import { UserService } from '../providers/user.service';
@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  currentUser;

  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number, private authService: AuthService, private userService: UserService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.currentUser = this.authService.getUser;

    const timeoutValue = request.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    const tackleRoutes = [`/portalApi/commitInvoice`, `/portalApi/commitRentalInvoice`]

    const url = request.url

    if (tackleRoutes.includes(url)) {
      request = request.clone({
        headers: request.headers.set('User-request-id', this.currentUser?.userRequestId)
      });
    }

    //console.log(this.currentUser); 

    const skipCredentialsUrls = [
      apiLinks.paymentForm,
      apiLinks.processTransaction,
      apiLinks.externalPaymentForm,
      apiLinks.getPosParams,
    ];
    const isGetPosParams = request.url.includes('/getPosParams');

    if (skipCredentialsUrls.indexOf(request.url) < 0) {
      request = request.clone({
        withCredentials: true,
      });
    }

    // Payment getPosParams uses its own `token` header; do not attach portal xaccesstoken.
    if (this.currentUser && this.currentUser?.accessToken && !isGetPosParams) {
      request = this.sendToken(request);
    }

    return next.handle(request).pipe(
      timeout(timeoutValueNumeric),
      catchError((error: HttpErrorResponse) => {
        if ((this.currentUser && error.status == 401) && (!error.url.includes("druid"))) {
          this.authService.logout(error?.error?.message);
        }
        return throwError(error);
      })
    );
  }

  sendToken(request: HttpRequest<any>) {
    // console.log(this.currentUser.roleFeatures)
    return request.clone({
      url: request.url.replace('http://', 'https://'),
      setHeaders: {
        xaccesstoken: this.currentUser.accessToken
        // roleFeatures: JSON.stringify(this.currentUser.roleFeatures)
      },
    });
  }
}
